import React from 'react'
import PropTypes from 'prop-types'
import TestimonialBG from './testimonial_bg.svg'
import DhsvBlogShareIcons from './share'
import { hyphenateSync } from 'hyphen/de'

class DhsvBlogItem extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      index,
      item,
      itemStyle,
      readMore,
      row,
      handleCategoryChange,
      isSlide,
    } = this.props

    const svg = ['magazin_2_spalten_left', 'magazin_2_spalten_right'].includes(
      row
    )
      ? atob(TestimonialBG.replace('data:image/svg+xml;base64,', ''))
      : false

    const backColor = item.fields.color ? item.fields.color : '#31363a'
    const opacity = item.fields.opacity ? item.fields.opacity : 0
    //(isSlide && !item.fields.client_advertisement) && opacity = 1

    // let styles = {}
    // if (item.fields.featured) {
    //   styles = {
    //     background: `linear-gradient(90deg, rgba(49,54,58,0) 0%, rgba(49,54,58,1) 99%), url(${item.post_thumbnail.large})`,
    //     backgroundSize: `cover`,
    //     backgroundPosition: `center center`,
    //   }
    // } else {
    //   styles = {
    //     background: `url(${item.post_thumbnail.large})`,
    //     backgroundSize: `cover`,
    //     backgroundPosition: `center center`,
    //   }
    // }
    return item ? (
      <div
        className={
          !item.fields.client_advertisement
            ? 'blog-item'
            : 'client-ad blog-item'
        }
        style={itemStyle ? itemStyle[index] : null}
      >
        <div className="inner">
          {item.fields.spotlight ? (
            <span className="spotlight-badge">
              <p>Spotlight</p>
            </span>
          ) : null}
          {!item.fields.featured_advertisement ? (
            <DhsvBlogShareIcons
              links={item.sharelinks}
              color={item.fields.teaser_share_icon_color}
            />
          ) : null}
          <a
            href={
              item.fields.featured_advertisement ||
              item.fields.client_advertisement
                ? item.fields.featured_advertisement_link
                : item.link
            }
            className="post-link"
          />
          {backColor != '#31363a' ? (
            <div
              className="image-shadow"
              style={{
                background: isSlide
                  ? `linear-gradient(to right, rgba(49, 54, 58, 0) 0%, ${backColor} 30%, ${backColor} 100%)`
                  : `linear-gradient(rgba(49, 54, 58, 0) 0%, ${backColor} 100%)`,
                opacity:
                  !item.fields.client_advertisement && !item.fields.opacity
                    ? 1
                    : opacity,
              }}
            />
          ) : null}
          <a
            href={
              item.fields.featured_advertisement ||
              item.fields.client_advertisement
                ? item.fields.featured_advertisement_link
                : item.link
            }
            className="image"
            {...(item.post_thumbnail
              ? { 'data-bg': item.post_thumbnail.large }
              : {})}
            style={{
              backgroundImage: `url(${
                index == 0 && item.post_thumbnail_big
                  ? item.post_thumbnail_big
                  : item.post_thumbnail_normal
                  ? item.post_thumbnail_normal
                  : item.post_thumbnail.large
              })`,
              backgroundSize: `cover`,
              backgroundPosition: `center center`,
            }}
          />
          {!item.fields.client_advertisement ? (
            <div className="meta">
              {svg ? (
                <div className="bg" dangerouslySetInnerHTML={{ __html: svg }} />
              ) : null}
              <div className="wrapper">
                <ul>
                  {item.categories
                    ? item.categories.map((cat, key) => (
                        <li key={key}>
                          <a
                            href={cat.link}
                            onClick={e => {
                              e.preventDefault()
                              handleCategoryChange(cat.id)
                            }}
                          >
                            {cat.name}
                          </a>
                        </li>
                      ))
                    : null}
                  <li className="date" hidden>
                    <a>{item.date_format}</a>
                  </li>
                </ul>
                <h3 className="blog-item__title">
                  <a
                    href={
                      item.fields.featured_advertisement
                        ? item.fields.featured_advertisement_link
                        : item.link
                    }
                    dangerouslySetInnerHTML={{
                      __html: hyphenateSync(item.title.rendered),
                    }}
                  />
                </h3>
                <div className="excerpt">
                  {item.fields.featured_advertisement
                    ? ' '
                    : item.excerpt + ' '}
                  {!item.fields.featured ? (
                    <a
                      href={
                        item.fields.featured_advertisement
                          ? item.fields.featured_advertisement_link
                          : item.link
                      }
                    >
                      {item.fields['title_teaser_button']
                        ? item.fields['title_teaser_button']
                        : readMore}
                    </a>
                  ) : (
                    <>
                      <a className="featured-button" href={item.link}>
                        {readMore}
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    ) : (
      <div className="">Loading</div>
    )
  }
}

DhsvBlogItem.propTypes = {
  isMD: PropTypes.bool,
  isSlide: PropTypes.bool,
  index: PropTypes.number,
  item: PropTypes.object,
  itemStyle: PropTypes.array,
  readMore: PropTypes.string,
  row: PropTypes.string,
  handleCategoryChange: PropTypes.func,
}

export default DhsvBlogItem
